/**
 * Option lists shared by registration, the listing/project editors and the dashboard.
 */
export const PROPERTY_TYPES = [
    { id: "apartment", label: "Apartment", icon: "🏢" },
    { id: "villa", label: "Villa", icon: "🏡" },
    { id: "plot", label: "Plot", icon: "🗺️" },
    { id: "commercial", label: "Commercial", icon: "🏬" },
    { id: "studio", label: "Studio", icon: "🛋️" },
    { id: "penthouse", label: "Penthouse", icon: "🏙️" },
    { id: "rowhouse", label: "Row House", icon: "🏘️" },
];

export const ACCOUNT_TYPES = [
    { id: "AGENT", label: "Agent / Broker", icon: "🤝", hint: "I list and sell homes for owners and builders" },
    { id: "BUILDER", label: "Builder / Developer", icon: "🏗️", hint: "I build projects and sell units directly" },
];

export const OPERATING_AREAS = [
    "Whitefield",
    "Electronic City",
    "Koramangala",
    "HSR Layout",
    "Indiranagar",
    "Marathahalli",
    "Sarjapur Road",
    "Bannerghatta Road",
    "Yelahanka",
    "Hebbal",
    "JP Nagar",
    "BTM Layout",
    "Bellandur",
    "Varthur",
    "Kengeri",
    "Rajajinagar",
    "Malleshwaram",
    "Jayanagar",
];

export const FURNISHING = ["Unfurnished", "Semi-Furnished", "Fully Furnished"];

export const FACINGS = ["East", "West", "North", "South", "North-East", "North-West", "South-East", "South-West"];

export const POSSESSION = [
    { id: "ready to move", label: "Ready to move" },
    { id: "under construction", label: "Under construction" },
    { id: "new launch", label: "New launch" },
];

export const COMMON_AMENITIES = [
    "Swimming Pool", "Gym", "Clubhouse", "Children's Play Area", "Power Backup", "Lift", "Covered Parking",
    "24x7 Security", "CCTV", "Garden", "Jogging Track", "Indoor Games", "Rainwater Harvesting", "Gated Community",
];

export const REVIEW_STATUS = {
    DRAFT: { label: "Draft", tone: "grey" },
    IN_REVIEW: { label: "In review", tone: "amber" },
    CHANGES_REQUESTED: { label: "Changes requested", tone: "red" },
    APPROVED: { label: "Approved", tone: "green" },
    REJECTED: { label: "Not approved", tone: "red" },
};
